import cloneDeep from 'lodash.clonedeep';
import { compile } from 'utils/searchURLs';
import { flux } from '../../../singletons';
import { history } from '../../../wlHistory';
import { Translator } from 'Translator';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';

const addDefaultArgumentsDecorator = (wrapped) => {
  return ({ filtersToAdd, replace = false }) => {
    const filters = flux.stores.FiltersStore.getFilters();
    wrapped(filters, history, { filtersToAdd, replace });
  };
};

const getExtraParams = (location) => {
  const currentSearchParams = new URLSearchParams(location.search);
  let extraSearchParams;
  if (currentSearchParams.has('company')) {
    extraSearchParams = new URLSearchParams({ company: currentSearchParams.get('company') });
  }
  return extraSearchParams;
}

function routeToSearchURL(filters, history, { filtersToAdd, replace = false }) {
  const newFilters = cloneDeep(filters);

  filtersToAdd.forEach((filterToAdd) => {
    const index = newFilters.activeFilters.findIndex(filter => filter.uid === filterToAdd.uid);

    if (index === -1) {
      newFilters.activeFilters.push(filterToAdd);
    } else {
      newFilters.activeFilters[index] = filterToAdd;
    }
  });

  newFilters.page = 1;

  // Remove filters without a value
  newFilters.activeFilters = newFilters.activeFilters.filter(activeFilter => activeFilter.subOptions.length > 0 || activeFilter.value !== '');

  const extraParams = getExtraParams(history.location);
  const searchPath = history.location.pathname.includes('/experiences/') ? '/experiences' : '/s';
  const [path, query] = compile(newFilters.country, newFilters.city, newFilters.page, newFilters.activeFilters, extraParams).split('?');
  const pathWithLangCode = generatePathnameWithLangCode(`${searchPath}${path}`, Translator.getLanguageCode());
  const redirectURL = query ? `${pathWithLangCode}?${query}` : pathWithLangCode;

  if (replace) {
    history.replace(redirectURL);
  } else {
    history.push(redirectURL);
  }
}

export default addDefaultArgumentsDecorator(routeToSearchURL);
